import { convertToDefaultDateFormat } from "@/util"

export const CM_EXAM_CONFIG = {
  ID: 'id',
  EXAM_DATE: 'exam_date',
  EXAM_TIME_FROM: 'exam_time_from',
  EXAM_TIME_TO: 'exam_time_to',
  LOCATION: 'location',
  CANDIDATES_COUNT: 'candidates_count',
  SLOTS_COUNT: 'slots_count',
  MIN_STUDENTS: 'min_students',
  MIJN_CBR_QUEUE_COUNT: 'mijn_cbr_queue_count',
  TOP_CBR_QUEUE_COUNT: 'top_cbr_queue_count',
  TOP_CBR_RESERVE_QUEUE_COUNT: 'top_cbr_reserve_queue_count',
  TOP_CBR_EXCHANGE_QUEUE_COUNT: 'top_cbr_exchange_queue_count',
}

export default class CMExamConfig {
  constructor(item = {}) {
    this.ID = item.id
    this.date = item[CM_EXAM_CONFIG.EXAM_DATE]
    this.timeFrom = item[CM_EXAM_CONFIG.EXAM_TIME_FROM]
    this.timeTo = item[CM_EXAM_CONFIG.EXAM_TIME_TO]
    this.location = item[CM_EXAM_CONFIG.LOCATION]
    this.candidates_count = item[CM_EXAM_CONFIG.CANDIDATES_COUNT]
    this.slots_count = item[CM_EXAM_CONFIG.SLOTS_COUNT]
    this.min_students = item[CM_EXAM_CONFIG.MIN_STUDENTS]
    this.mijn_cbr_queue_count = item[CM_EXAM_CONFIG.MIJN_CBR_QUEUE_COUNT]
    this.top_cbr_queue_count = item[CM_EXAM_CONFIG.TOP_CBR_QUEUE_COUNT]
    this.top_cbr_reserve_queue_count = item[CM_EXAM_CONFIG.TOP_CBR_RESERVE_QUEUE_COUNT]
    this.top_cbr_exchange_queue_count = item[CM_EXAM_CONFIG.TOP_CBR_EXCHANGE_QUEUE_COUNT]
  }
}

export class CMOverviewExamConfigDecorator {
  constructor(examConfig) {
    this.examConfig = examConfig;
  }

  convert() {
    return {
      ...this.examConfig,
      formatted_date: convertToDefaultDateFormat(this.examConfig.date),
      formatted_timeFrom: this.examConfig.timeFrom.slice(0, this.examConfig.timeFrom.lastIndexOf(':')),
      formatted_timeTo: this.examConfig.timeTo.slice(0, this.examConfig.timeTo.lastIndexOf(':'))
    }
  }
}

export class CMExamHourFormatter {
  constructor(item = {}) {
    this.item = item
  }

  execute() {
    let item = {...this.item}
    item[CM_EXAM_CONFIG.EXAM_TIME_FROM] = item[CM_EXAM_CONFIG.EXAM_TIME_FROM].split(':')
    item[CM_EXAM_CONFIG.EXAM_TIME_FROM].pop()
    item[CM_EXAM_CONFIG.EXAM_TIME_FROM] = item[CM_EXAM_CONFIG.EXAM_TIME_FROM].join(':')
    item[CM_EXAM_CONFIG.EXAM_TIME_TO] = item[CM_EXAM_CONFIG.EXAM_TIME_TO].split(':')
    item[CM_EXAM_CONFIG.EXAM_TIME_TO].pop()
    item[CM_EXAM_CONFIG.EXAM_TIME_TO] = item[CM_EXAM_CONFIG.EXAM_TIME_TO].join(':')
    return item
  }
}

export class CMExamConfigApiData {
  constructor(data) {
    this.data = data
  }

  convert() {
    return {
      [CM_EXAM_CONFIG.EXAM_DATE]: this.data.date,
      [CM_EXAM_CONFIG.EXAM_TIME_FROM]: this.data.timeFrom,
      [CM_EXAM_CONFIG.EXAM_TIME_TO]: this.data.timeTo,
      [CM_EXAM_CONFIG.LOCATION]: this.data.location
      
    }
  }
}